$(window).on('scroll', function () {
  if ($(window).scrollTop() > 50) {
    $(".visitor-navbar").addClass('fixed-header');
  } else {
    $(".visitor-navbar").removeClass('fixed-header');
  }
});
